module.exports = __webpack_public_path__ + "static/img/activity_sdy_05-1.f7c1eda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_05-1.jpg
// module id = tu3Q
// module chunks = 0